/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character Inspector — Unicode Code Points & UTF-8 | Toolverse`)
};

const es_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de Caracteres — Puntos de código Unicode y UTF-8 | Toolverse`)
};

const de_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen-Inspektor — Unicode-Codepunkte & UTF-8 | Toolverse`)
};

const nl_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakterinspecteur — Unicode-codepunten & UTF-8 | Toolverse`)
};

const fr_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur de caractères — Points de code Unicode et UTF-8 | Toolverse`)
};

const it_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore di Caratteri — Punti di Codice Unicode e UTF-8 | Toolverse`)
};

const pt_br2_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de Caracteres — Pontos de Código Unicode e UTF-8 | Toolverse`)
};

const pt_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de Caracteres — Pontos de código Unicode e UTF-8 | Toolverse`)
};

const ja_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「文字インスペクタ — Unicode コードポイント & UTF-8 | Toolverse」`)
};

const zh_ci_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符检查器 — Unicode 码点与 UTF-8 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_meta_title", locale)
	if (locale === "en") return en_ci_meta_title(inputs)
	if (locale === "es") return es_ci_meta_title(inputs)
	if (locale === "de") return de_ci_meta_title(inputs)
	if (locale === "nl") return nl_ci_meta_title(inputs)
	if (locale === "fr") return fr_ci_meta_title(inputs)
	if (locale === "it") return it_ci_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ci_meta_title(inputs)
	if (locale === "pt") return pt_ci_meta_title(inputs)
	if (locale === "ja") return ja_ci_meta_title(inputs)
	return zh_ci_meta_title(inputs)
};